import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { Employee, toEmployeeXml } from './CreateCompanyPersonRelationRequest';

export interface IDeleteCompanyPersonRelationRequest extends IBaseRequest {
    EMPLOYEE: Employee;
}


export class DeleteCompanyPersonRelationRequest extends BaseRequest implements IDeleteCompanyPersonRelationRequest {
    public EMPLOYEE: Employee;

    constructor(server: string, session: string, employee: Employee) {
        super(server, session);
        this.EMPLOYEE = employee;
    }

  public toXml(): string {
    var parameters: string = super.toXml();
    parameters += toEmployeeXml(this.EMPLOYEE);
    return super.wrapperXml('DeleteCompanyPersonRelation', parameters);
  }
}
